/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfiguredGraph } from '../../models/configured-graph';

export interface GetConfiguredGraph$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the configured graph
 */
  graphUid: string;
}

export function getConfiguredGraph(http: HttpClient, rootUrl: string, params: GetConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredGraph>> {
  const rb = new RequestBuilder(rootUrl, getConfiguredGraph.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('graphUid', params.graphUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfiguredGraph>;
    })
  );
}

getConfiguredGraph.PATH = '/stations/{uid}/graph/configured/{graphUid}';
